<template>
  <div class="mt-sm-4">
    <h4 class="mb-2 text-info">
      {{ "status_bank" | setText("Статус банка") }}:
      <span
        v-if="
          data.status &&
          data.status.data &&
          data.status.data.status &&
          status[data.status.data.status]
        "
        >{{ status[data.status.data.status] }}</span
      >
      <span v-else>{{ "no" | setText("Нет") }}</span>
    </h4>
    <h5 class="mb-2 text-danger">
      {{ "number" | setText("Номер") }}: #
      <span v-if="data.exchange_id">{{ data.exchange_id }}</span>
      <span v-else>-</span>
    </h5>
    <component :is="data.state" :data="data" v-model="setValue" />
  </div>
</template>
<script>
export default {
  methods: {},
  components: {
    new: () => import("./new"),
    sent: () => import("./sent"),
    reject: () => import("./reject"),
    approve: () => import("./approve"),
    cancel: () => import("./cancel"),
    done: () => import("./done"),
  },
  data: () => ({
    status: {
      new: "Новая заявка",
      pre_scoring_ok: "Прескоринг одобрен",
      pre_scoring_nok: "Прескоринг не одобрен",
      underwriter: "Андеррайтер рассматривает документы",
      underwriter_ok: "Андеррайтер одобрил",
      underwriter_nok: "Андеррайтер не одобрил",
      loan_officer: "Кредитный эксперт",
      loan: "Выдали кредит",
      cancelled: "Заявка отменена",
      problem: "Проблемный кредит",
      insurance: "Страховка оплатила",
      completed: "Завершённая заявка",
    },
  }),
  props: ["value", "data"],
  computed: {
    setValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style>
</style>
 